import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';
import { Section } from 'features/home/components/home-page/styles';
import { StyleSheet } from 'react-native';

import { MarketingTileSkeleton } from 'components/marketing-tile/marketing-tile.skeleton';
import { CenteredRowContainer } from 'components/ui/centered-row-container';
import { useContentCardsNotificationsExperiment } from 'experiments/use-content-cards-notifications';
import { spacing } from 'styles/constants';

import { HeroSkeleton } from './hero.skeleton';

type HomePageSkeletonProps = {
  headerComponent?: React.ReactElement | null;
};

export const HomePageSkeleton = React.memo(({ headerComponent }: HomePageSkeletonProps) => {
  // Treatment moves marketing cards to the notification inbox, so the home skeleton
  // must not show marketing tile placeholders that will never resolve here.
  const { isNewsFeedEnabled } = useContentCardsNotificationsExperiment();

  return (
    <ScrollView>
      {headerComponent}
      <HeroSkeleton />
      {!isNewsFeedEnabled ? (
        <CenteredRowContainer standardPadding containerStyle={styles.cardsContainer}>
          <Section first last shouldRenderDefaultBackground>
            <MarketingTileSkeleton />
          </Section>
        </CenteredRowContainer>
      ) : null}
    </ScrollView>
  );
});

const styles = StyleSheet.create({
  cardsContainer: {
    marginTop: spacing.$4,
  },
});
